import { ReactElement } from "react";
import { GetStaticProps } from "next";
import { NextSeo } from "next-seo";
import { MainLayout } from "~/components/layouts/MainLayout";
import { StandardServicePage } from "~/components/service-pages/StandardServicePage";
import { HeatPumpInspectionContent as content } from "~/content/przeglad-pompy-ciepla/content.pl";
import { getRecentPostsForService, type PostMeta } from "~/lib/mdx";
import { getServiceBySlug } from "~/lib/services";
import { NextPageWithLayout } from "~/pages/_app";
import hallwayImage from "~/src/assets/images/hero-hallway.webp";
import housesImage from "~/src/assets/images/hero-houses-aerial.jpg";
import residentialImage from "~/src/assets/images/services-projects-residential.webp";

type Props = {
  recentPosts: PostMeta[];
};

const serviceSlug = "przeglad-pompy-ciepla";
const service = getServiceBySlug(serviceSlug);

if (!service) {
  throw new Error(`Service not found: ${serviceSlug}`);
}

const pageUrl = `${(
  process.env.NEXT_PUBLIC_BASE_URL ?? "https://inspektomat.pl"
).replace(/\/+$/, "")}${service.href}`;

const sectionImages = [
  {
    src: hallwayImage,
    alt: "Przegląd pompy ciepła w budynku mieszkalnym",
  },
  {
    src: housesImage,
    alt: "Dom jednorodzinny z instalacją pompy ciepła",
  },
  {
    src: residentialImage,
    alt: "Instalacja grzewcza w domu po serwisie pompy ciepła",
  },
] as const;

const HeatPumpInspectionPage: NextPageWithLayout<Props> = ({ recentPosts }) => {
  return (
    <StandardServicePage
      serviceSlug={serviceSlug}
      content={content}
      sectionImages={sectionImages}
      recentPosts={recentPosts}
    />
  );
};

HeatPumpInspectionPage.getLayout = function GetLayout(page: ReactElement) {
  return (
    <MainLayout>
      <NextSeo
        title={content.seo.title}
        description={content.seo.description}
        openGraph={{
          title: content.seo.title,
          description: content.seo.description,
          url: pageUrl,
        }}
      />
      {page}
    </MainLayout>
  );
};

export default HeatPumpInspectionPage;

export const getStaticProps: GetStaticProps<Props> = async () => {
  return {
    props: {
      recentPosts: getRecentPostsForService(serviceSlug),
    },
  };
};
